export default __webpack_public_path__ + "static/media/power-line-connected-towers.190be64b.png";